module.exports = __webpack_public_path__ + "static/img/244_TO8_2192.0d882a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/244_TO8_2192.jpg
// module id = Y/L5
// module chunks = 0